import { isNil } from "lodash";
import { getChannel } from "../channel/api/getChannel";
import type { RocketchatResponseHandler } from "../RocketchatResponseHandler";
import { store } from "../redux/store";
import { SocketClient } from "../socket/socketClient";
import { renewChannelEventThunk } from "./chatEventThunk";

export const handleRenewChannelEventHandler: RocketchatResponseHandler =
  async ({ response }) => {
    const renewChannel = response?.renew_channel;

    if (isNil(renewChannel)) {
      console.error("renewChannelEventHandler: renewChannel is nil");
      return;
    }

    const socket = SocketClient.getInstance().getWebSocket();

    const { channel, users, raw } = await getChannel(
      {
        channelId: renewChannel.channel_id,
      },
      socket,
    );

    if (isNil(channel)) {
      console.error(
        `renewChannelEventHandler: normalized channel is nil: ${JSON.stringify(
          raw,
        )}`,
      );
      return;
    }

    store.dispatch(
      renewChannelEventThunk({
        channel,
        lastChatMessage: undefined,
        users,
      }),
    );
  };
